import React, { useState, useEffect, useCallback } from 'react';
import { Typography, Button, Tooltip, Chip, Paper, InputLabel} from '@mui/material';
import Grid from '@mui/material/Grid2';
import { myApi } from '../../config/axiosConfig';
import useMediaQuery from '@mui/material/useMediaQuery';
import Swal from 'sweetalert2';
import MiTabla from '../../components/plantilla/tabla/MiTabla';
import { GridActionsCellItem } from '@mui/x-data-grid';
import { green, red } from '@mui/material/colors';
import BtnAcciones from '../../components/plantilla/tabla/BtnAcciones';
import { LocalizationProvider, dateCalendarClasses } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

// Iconos
import AddCircleIcon from '@mui/icons-material/AddCircle';
import DeleteIcon from '@mui/icons-material/Delete';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';

// Modales
import CrearEditarUsuarioModal from './modales/CrearEditarUsuarioModal';

const Master = () => {

    var Locale = "es-mx";

    const isNonMobile = useMediaQuery("(min-width:600px)");

    const [data, setData] = useState([]);

    const [loading, setLoading] = useState(false);

    const columns = [        
        { field: 'Date', headerName: 'Date',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        {
            field: 'Unit', headerName: 'Unit',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { field: 'Gal_Consumed', headerName: 'Gal Consumed',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { field: 'MPG', headerName: 'MPG',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { field: 'Fuel_Purchased', headerName: 'Fuel Purchased',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { field: 'Gallons_Purchased', headerName: 'Gallons Purchased',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { field: 'PPG', headerName: 'PPG',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { field: 'Fuel_City_State', headerName: 'Fuel City/State',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { field: 'Delivered_Miles', headerName: 'Delivered Miles',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
    ];

    const fetch = async () => {
        try {
            const response = await myApi.get('endpoint/master/masterindicator/2024/11');
            setData(response.data[0]);
            console.log(response.data[0])
        } catch (error) {
            console.error('Error fetching:', error);
        } finally {
            setLoading(false); 
        }
    };

    useEffect(() => {
        fetch();
    }, []);
    return (
        <Paper sx={{padding: 2}}>
            <Grid container>
                <Grid size={{ xs: 12, md: 8 }}>
                    <Typography variant="h4" fontWeight="bold" marginBottom={2}>
                        Indicador
                    </Typography>
                </Grid>
                <Grid item size={{ xs: 12, md: 4 }}
                    sx={{
                        display: 'flex',
                        justifyContent: isNonMobile ? 'flex-end' : 'start'
                    }}>
                </Grid>
                <Grid size={12}
                    marginTop={1}>
                    <MiTabla
                        columns={columns}
                        data={data}
                        loading={loading}
                    />
                </Grid>
            </Grid>
        </Paper>

    )

}

export default Master